import swal from "sweetalert";
import { updateRequest } from '../dataApi'

export const reversePurchaseOrder = async (request) => {
    const setFinal = await swal({text: "Se procedera a reversar la Compra, ¿Desea continuar?", icon: "info", buttons: ["Cancelar", "Continuar"],})
    
    if(!setFinal) return false

    await updateRequest({
        id: request,
        reverse: true,
        purchaseOrder: true,
        purchase: false,
        status: 'EN PROCESO DE COMPRA'
    })

    return true
}